import type { LoaderFunctionArgs } from '~/types/route-args';
import { getDirectoryItemByIDs } from '~/modules/directory/api/get-directory-items-admin.server';

/**
 * Get the admin metadata for directory items with the given IDs in the search
 * params.
 */
export const loader = async ({ request, context }: LoaderFunctionArgs) => {
    const url = new URL(request.url);
    const idsParams = url.searchParams.getAll('IDs');
    const ids = idsParams
        .map((idParam) => parseInt(idParam.toString()))
        .filter(isFinite);

    const items = await getDirectoryItemByIDs({ ...context, IDs: ids });

    return { items };
};

export const QUERY_DIRECTORY_ITEMS_ADMIN =
    '/remix-api/directory/get-directory-items-admin';
